import { CircleHelp } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { cn } from "@/modern/utils";

interface PromoteStepHelpTriggerProps {
  /** Step name for accessibility, e.g. "Classify" */
  stepLabel: string;
  helpText: string;
  className?: string;
}

export const PromoteStepHelpTrigger = ({ stepLabel, helpText, className }: PromoteStepHelpTriggerProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={cn(
            "inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors",
            "hover:bg-muted hover:text-foreground",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
            className,
          )}
          aria-label={`What is ${stepLabel}?`}
        >
          <CircleHelp className="w-4 h-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        align="end"
        sideOffset={6}
        className="max-w-[240px] text-left z-[--swivu-bryntum-z-index] border"
      >
        {helpText}
      </TooltipContent>
    </Tooltip>
  );
};
